
import state from './moduleMailBoxState.js'
import mutations from './moduleMailBoxMutations.js'
import actions from './moduleMailBoxActions.js'
import getters from './moduleMailBoxGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
